import { readItemListConfig } from "./item-list-model";
import React, { useState } from "react";
export default function ItemListPreview({ config }) {
  const [showAll, setShowAll] = useState(false);
  config = readItemListConfig(config);
  if (!config) return <p className="secondary" role="alert">The saved item list could not be loaded. Please reload the survey before editing this category.</p>;
  return <div className="uk-margin-small-top">
    <p className="secondary">{config.items.length} items · {config.required ? "At least one selection required" : "Optional"}{config.custom_items_allowed ? " · Custom items allowed" : ""}</p>
    <ul className="uk-list">{config.items.slice(0, showAll ? config.items.length : 5).map((item) => <li key={item.id}>{item.name}{item.unit ? ` (${item.unit})` : ""}</li>)}</ul>
    {config.items.length > 5 && <button type="button" className="uk-button hms-btn hms-white-btn" aria-expanded={showAll} onClick={() => setShowAll((expanded) => !expanded)}>{showAll ? "Show less" : "Show all"}</button>}
  </div>;
}
